import React from 'react'

const SvgTrashFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 4c0-1.333.667-2 2-2h2c1.333 0 2 .667 2 2h3c1.333 0 2 .667 2 2v2H4V6c0-1.333.666-2 1.999-2H9zm10 6v10c0 1.333-.667 2-2 2H7c-1.336 0-2.003-.667-2-2V10h14zM9 14v4c0 .667.333 1 1 1s1-.333 1-1v-4c0-.676-.333-1.01-1-1-.667.01-1 .343-1 1zm4 0v4c0 .667.333 1 1 1s1-.333 1-1v-4c0-.676-.333-1.01-1-1-.667.01-1 .343-1 1z'
    />
  </svg>
)

export default SvgTrashFilled
